import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { SessionDataService } from './service/session-data.service';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { ConfigService } from 'src/app/services/config.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Title } from '@angular/platform-browser';
import { ArchiveDashboardService } from './archive-dashboard/archive-dashboard.service';

@Component({
  selector: 'app-user-behaviour',
  templateUrl: './user-behaviour.component.html',
  styleUrls: ['./user-behaviour.component.css']
,
  standalone: false
})
export class UserBehaviourComponent implements OnInit {
  dataSource: MatTableDataSource<any>;
  displayedColumns: string[] = ['userId', 'action', 'timestamp'];
  startDate: Date;
  endDate: Date;
  pageIndex = 0;
  pageSize = 5;
  totalItems:number;
  activeUsers: number = 0;
  inactiveUsers: number = 0;
  selectedTab = localStorage.getItem('selectedTab') || 0;
  isAdminUser = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('tabGroup') tabGroup!: MatTabGroup;
  showCPLogs = false;

  constructor(
    private http: HttpClient,
    private sessionDataService: SessionDataService, 
    public configService: ConfigService,
    private authService: AuthenticationService,
    private titleService: Title
  ) { 

    this.titleService.setTitle("PV Admin Portal");
  }

  ngOnInit(): void {
    const currentUser = this.authService.currentUserValue;
    this.isAdminUser = ArchiveDashboardService.isAdminUser(currentUser?.email);
    //this.dataSource = new MatTableDataSource<any>([]);
    //this.fetchSessionData();
    //this.fetchLogs();
    //console.log("*init >>", this.authService.hasPrivilege('View Proview'));
    this.showCPLogs = this.authService.hasPrivilege('VIEW_CP_METRICS');
  }
  
  // ngAfterViewInit() {
  //   this.dataSource.paginator = this.paginator;
  //   this.pageSize = this.paginator.pageSize;
  // }
  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // Adding 1 because getMonth() returns 0-indexed month
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  // refreshData(): void {
  //   console.log("refreshData")
  // }

  formatEndDate(date: Date): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // Adding 1 because getMonth() returns 0-indexed month
    let day;
    if (this.isToday(date)) {
      date.setDate(date.getDate() + 1);
      day = date.getDate();
    } else {
      day = ('0' + date.getDate()).slice(-2);
    }
    return `${year}-${month}-${day}`;
  }
  isToday(date: Date): boolean {
    const today = new Date();
    return date.getFullYear() === today.getFullYear() &&
           date.getMonth() === today.getMonth() &&
           date.getDate() === today.getDate();
  }

  onTabChange(event: MatTabChangeEvent) {
    const prevTab = this.selectedTab;
  this.selectedTab = event.index.toString();
  localStorage.setItem('selectedTab', this.selectedTab);
  
  if (prevTab === '1' && this.selectedTab !== '1') {
    localStorage.removeItem('userSessionFilters');
  }
  
}

  switchTab(index: number) {
  this.selectedTab = index;
  localStorage.setItem('selectedTab', index.toString());
  } 
  fetchLogs() {
    let url = `http://localhost:3000/api/logsPaginated?page=${this.pageIndex + 1}&pageSize=${this.pageSize}`;

    if (this.startDate && this.endDate) {
      const startDateString = this.formatDate(this.startDate);
      const endDateString = this.formatEndDate(this.endDate);
      url += `&startDate=${startDateString}&endDate=${endDateString}`;    
    }
    this.http.get<any>(url).subscribe(
      response => {
        this.totalItems = response.totalLogs;
        this.dataSource = new MatTableDataSource<any>(response.logs);
      }
    );
  }
  
  handlePageChange(event: any): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    // Fetch logs with updated pagination parameters
    this.fetchLogs();
  }

  onPageChange(event: PageEvent): void {
    const page = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.fetchLogs();
  }

  onPageSizeChange(pageSize: any): void {
    this.pageSize = pageSize;
    this.fetchLogs();
  }

  // fetchSessionData(): void {
  //   this.sessionDataService.getSessions().subscribe(sessionData => {
  //     this.calculateActiveAndInactiveUsers(sessionData);
  //   });
  // }

  calculateActiveAndInactiveUsers(sessionData: any[]): void {
    this.activeUsers = sessionData.filter(session => !session.logoutTimeInIST).length;
    this.inactiveUsers = sessionData.filter(session => session.logoutTimeInIST).length;
  }
}
